import type { Permission } from '@btsis/core';

export const FINANCE_GUIDE_PATH = '/help/finance';

/**
 * Whoever reads any finance list may read the guide: it explains exactly the
 * screens those permissions open, and it changes nothing. The guide itself
 * reads no organization's money, so a `self` session holding one of these is
 * offered it too.
 */
export const FINANCE_GUIDE_PERMISSIONS: readonly Permission[] = [
  'statement.list',
  'reconciliation.list',
  'refund.list',
  'fundTransfer.list',
  'finance.view',
  'receipt.list',
  'exchangeRate.list',
];

export const FINANCE_GUIDE_SECTION_IDS = [
  'basics',
  'organizations',
  'statements',
  'matching',
  'manualPayments',
  'approvals',
  'shortfalls',
  'refunds',
  'fundTransfers',
  'cardPayouts',
  'balances',
  'receipts',
  'exchangeRates',
  'undo',
  'paymentKeys',
  'roles',
] as const;

export type FinanceGuideSectionId = (typeof FINANCE_GUIDE_SECTION_IDS)[number];

export function isFinanceGuideSectionId(value: string): value is FinanceGuideSectionId {
  return (FINANCE_GUIDE_SECTION_IDS as readonly string[]).includes(value);
}

export const financeGuideHref = (section: FinanceGuideSectionId) =>
  `${FINANCE_GUIDE_PATH}#${section}`;
